/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Campaign } from '../../model/campaigns';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import IconFileCode from '@cimpress-technology/react-streamline-icons/lib/IconFileCode';
import IconAnalyticsPieAlt from '@cimpress-technology/react-streamline-icons/lib/IconAnalyticsPieAlt';
import { IconButton } from '../iconButton';
import { AppState } from '../../store/store';
import { getCampaigns } from '../../store/campaigns/actions';
import { CampaignDatesInfo } from './campaignDatesInfo';
import { DeleteCampaignAction } from '../actions/deleteCampaignAction';
import { AccessManagementAction } from '../actions/accessManagementAction';
import { DownloadCampaignReportAction } from '../actions/downloadCampaignReportAction';
import { CampaignForm } from './campaignForm';

export interface CampaignInfoProps {
    campaign: Campaign;
}

const renderActionBar = (t, i18n, accessToken: string, campaign: Campaign) => {
  return <div className='flexContainer actionBar'>
    <div className='flexChild'>
      <IconButton disabled={true} size={'3x'} tooltip={t('campaigns.buttonGetCode')} onClick={() => {
      // disable for now as we don't have clear vision on how to show it.
      }} icon={IconFileCode}/>
    </div>
    <div className='flexChild'>
      <AccessManagementAction groupUrl={campaign?._links?.coamGroup?.href || ''}/>
    </div>
    <div className='flexChild'>
      <DownloadCampaignReportAction campaign={campaign}/>
    </div>
    <div className='flexChild'>
      <Link to={`/campaigns/${campaign?.campaignId}/results`}>
        <IconButton size={'3x'} tooltip={t('campaigns.actions.results.tooltip')} icon={IconAnalyticsPieAlt}/>
      </Link>
    </div>
  </div>;
};

export const CampaignInfo: React.FC<CampaignInfoProps> = ({ campaign }) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const { accessToken } = useSelector((state: AppState) => state.auth);
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);

  return <div className={'campaign-info-pane'}>

    {renderActionBar(t, i18n, accessToken, campaign)}

    <br/>

    <CampaignForm
      campaign={campaign}
      onSaving={isSaving => {
        setSaving(isSaving);
      }}/>

    <br/>

    <CampaignDatesInfo campaign={campaign}/>

    <DeleteCampaignAction
      disabled={saving}
      campaignId={campaign.campaignId}
      campaignTitle={campaign.title}
      onDeleted={() => {
        dispatch(getCampaigns());
        history.push('/campaigns');
      }}
    />
    
  </div>;
};
